import React from 'react';
import {Box, HStack} from '@chakra-ui/react';
import {useNavigate} from 'react-router-dom';
import {TextG14} from '../typography';
import {isBookmarkChallengeActive, BOOKMARK_CHALLENGE_DETAILS_PATH} from '../../constants/challengeConfig';
import Icon from '../Icon';

const ChallengeBanner = () => {
  const navigate = useNavigate();

  if (!isBookmarkChallengeActive()) {
    return null;
  }

  return (
    <Box
      bg="#FFEDF6"
      px={4}
      py={3}
      cursor="pointer"
      onClick={() => navigate(BOOKMARK_CHALLENGE_DETAILS_PATH)}
      _active={{transform: 'scale(0.98)'}}>
      <HStack spacing={2} align="center">
        <Icon iconName="fi fi-sr-star" style={{fontSize: '16px', color: '#C9136B'}} />
        <TextG14 color="#262626" fontWeight="500">
          Every save enters you to win{' '}
          <TextG14 as="span" fontWeight="700" color="#C9136B">
            $500
          </TextG14>{' '}
          (
          <TextG14 as="span" color="#C9136B" fontWeight="600" textDecoration="underline">
            see details
          </TextG14>
          )
        </TextG14>
      </HStack>
    </Box>
  );
};

export default ChallengeBanner;
